import * as React from "react";

export const NOT_RECORDED_RED = "#f87171";

// Read aloud as "Not recorded": a screen reader would otherwise say "dash dash".
export const NotRecorded: React.FC = () => (
  <span role="img" aria-label="Not recorded" title="Not recorded" style={{ color: NOT_RECORDED_RED }}>
    --
  </span>
);
